import { useParams } from 'react-router-dom';
import { H5pConstructorPage } from './H5pConstructorPage';

/** Edición de paquete H5P existente — reutiliza el shell del constructor. */
export function H5pEditPage() {
  const { id } = useParams<{ id: string }>();
  return <H5pConstructorPage packageId={id} mode="edit" />;
}
